var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAutoCard1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 48.5C20 46.8431 21.3432 45.5 23 45.5H52.9999C54.6568 45.5 55.9999 46.8431 55.9999 48.5C55.9999 51.8138 53.3137 54.5 49.9999 54.5H26C22.6863 54.5 20 51.8138 20 48.5Z",
    stroke: "url(#paint0_linear_4132_28638)",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3703 9.48701C47.1155 8 44.0768 8 37.9994 8C31.922 8 28.8832 8 26.6287 9.48701C25.9132 9.95894 25.2688 10.5306 24.715 11.1848C22.9699 13.2461 22.6079 16.2632 21.8838 22.2974L21.611 24.5702C20.8596 30.8326 20.4838 33.9637 22.2742 35.9818C24.0647 37.9999 27.2183 37.9999 33.5255 37.9999H42.4733C48.7805 37.9999 51.9341 37.9999 53.7245 35.9818C55.5152 33.9637 55.1393 30.8326 54.3878 24.5702L54.1151 22.2974",
    stroke: "url(#paint1_linear_4132_28638)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38 38V44",
    stroke: "url(#paint2_linear_4132_28638)",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9999 67.9999V62M37.9999 62V54.5M37.9999 62H39.4999C42.4999 62 44.5657 65.1973 45.4999 67.9999M37.9999 62H36.4999C33.4999 62 31.4342 65.1973 30.5 67.9999M20 48.5L17 41C15.5 38 14 36.5 8 36.5M55.9999 48.5L58.9999 41C60.4999 38 61.9999 36.5 67.9999 36.5",
    stroke: "url(#paint3_linear_4132_28638)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4132_28638",
    x1: 21.3589,
    y1: 45.2577,
    x2: 24.888,
    y2: 61.3269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4132_28638",
    x1: 22.2708,
    y1: 7.19231,
    x2: 49.4524,
    y2: 42.2871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4132_28638",
    x1: 38.0377,
    y1: 37.8385,
    x2: 40.0942,
    y2: 38.2286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4132_28638",
    x1: 10.2649,
    y1: 35.6519,
    x2: 32.6858,
    y2: 84.2665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoCard1);
export default __webpack_public_path__ + "static/media/auto_card1.e81fe9dcf8075bd6ea18c4db9ce9551c.svg";
export { ForwardRef as ReactComponent };